import React, { Component } from 'react';

class AICatSupport extends Component {

  render() {
    return (
      <div style={{ padding: '20px', color: 'white'}}>
        <h1>AICat Introduction</h1>
        <p>Welcome to AICat, a cutting-edge chat app that utilizes the power of ChatGPT technology to provide an unparalleled messaging experience. With AICat, users can engage in natural and seamless conversations with AI-powered chatbots, personalized to your preferences.</p>
        <p>One of the key features of AICat is the ability to create custom prompts for your chat sessions. This allows you to steer the conversation in a direction that you desire, and to easily switch between prompts during different chat sessions to keep things fresh and interesting.</p>
        <p>AICat also offers a range of advanced features to enhance your messaging experience, including multi-language support, real-time translations, and an intuitive user interface that puts you in complete control.</p>
        <p>So why wait? Join the AICat revolution today and experience the power of ChatGPT in the palm of your hands. Download AICat now on the App Store and open up a world of limitless communication possibilities.</p>
        <h2>Contact Us</h2>
        <ul>
            <li>Team：AICat Team</li>
            <li>Telephone：+8618362972606</li>
            <li>Email：iplay.coder@gmail.com</li>
        </ul>
      </div>
    );
  }
}

export default AICatSupport